import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ConfirmChangeEmail from '../../../components/UserAccount/Confirms/ConfirmChangeEmail/ConfirmChangeEmail';
import ConfirmNewEmail from '../../../components/UserAccount/Confirms/ConfirmNewEmail/ConfirmNewEmail';
import ConfirmPayoutCustomerApprove from './ConfirmPayoutCustomerApprove';

const Confirm = () => (
  <React.Fragment>
    <Switch>
      <Route path="/confirm/new-email" render={() => <ConfirmNewEmail />} />
      <Route
        path="/confirm/change-email"
        render={() => <ConfirmChangeEmail />}
      />
      <Route
        path="/confirm/payout-customer-approve"
        render={() => <ConfirmPayoutCustomerApprove />}
      />
    </Switch>
  </React.Fragment>
);

export default Confirm;



// WEBPACK FOOTER //
// ./src/lauoyts/Common/Confirm/Confirm.js